export interface ApplePayRegistrationError {
  locationId: string;
  merchantId: string;
  domain: string;
  message: string;
  errorMessage: string;
  appleStatusCode: number;
}

export function toApplePayError(obj: any): ApplePayRegistrationError | null {
  const isValid = (
    obj &&
    typeof obj.domain === 'string' &&
    typeof obj.errorMessage === 'string' &&
    typeof obj.appleStatusCode === 'number'
  );

  return isValid ? (obj as ApplePayRegistrationError) : null;
}
